"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const input_1 = __importDefault(require("../input/input"));
const useCharCount_1 = __importDefault(require("./useCharCount"));
const CharacterCountTextInput = ({ value, maxLength, onChange, className, multiline, ...props }) => {
    const { handleChange, component } = (0, useCharCount_1.default)({ shouldCountChars: true, onChange, maxLength, value, multiline });
    return (react_1.default.createElement(input_1.default, { variant: "outlined", className: `character-count-text-input ${className}`, value: value || '', InputProps: {
            endAdornment: component,
        }, multiline: multiline, onChange: handleChange, ...props }));
};
CharacterCountTextInput.defaultProps = {
    value: '',
    maxLength: 255,
    className: '',
    error: false,
};
CharacterCountTextInput.propTypes = {
    value: prop_types_1.default.string,
    maxLength: prop_types_1.default.number,
    onChange: prop_types_1.default.func.isRequired,
    className: prop_types_1.default.string,
    error: prop_types_1.default.bool,
};
exports.default = CharacterCountTextInput;
//# sourceMappingURL=character-count-text-input.js.map